import react from "react";

import UYN1 from "../images/commercials/UYN/UYN_FINAL_001 copy Medium.jpeg";
import UYN2 from "../images/commercials/UYN/UYN_FINAL_002 copy Medium.jpeg";
import UYN3 from "../images/commercials/UYN/UYN_FINAL_003 copy Medium.jpeg";
import UYN4 from "../images/commercials/UYN/UYN_FINAL_004 copy Medium.jpeg";
import UYN5 from "../images/commercials/UYN/UYN_FINAL_005 copy Medium.jpeg";
import UYN6 from "../images/commercials/UYN/UYN_FINAL_006 copy Medium.jpeg";
import UYN7 from "../images/commercials/UYN/UYN_FINAL_007 copy Medium.jpeg";
import UYN8 from "../images/commercials/UYN/UYN_FINAL_008 copy Medium.jpeg";
import UYN9 from "../images/commercials/UYN/UYN_FINAL_009 copy Medium.jpeg";
import UYN10 from "../images/commercials/UYN/UYN_FINAL_010 copy Medium.jpeg";
import UYN11 from "../images/commercials/UYN/UYN_FINAL_011 copy Medium.jpeg";
import UYN12 from "../images/commercials/UYN/UYN_FINAL_012 copy Medium.jpeg";
import UYN13 from "../images/commercials/UYN/UYN_FINAL_013 copy Medium.jpeg";
import UYN14 from "../images/commercials/UYN/UYN_FINAL_014 copy Medium.jpeg";
import UYN15 from "../images/commercials/UYN/UYN_FINAL_015 copy Medium.jpeg";
import UYN16 from "../images/commercials/UYN/UYN_FINAL_016 copy Medium.jpeg";
import UYN17 from "../images/commercials/UYN/UYN_FINAL_017 copy Medium.jpeg";
import UYN18 from "../images/commercials/UYN/UYN_FINAL_018 copy Medium.jpeg";
import UYN19 from "../images/commercials/UYN/UYN_FINAL_019 copy Medium.jpeg";
import UYN20 from "../images/commercials/UYN/UYN_FINAL_020 copy Medium.jpeg";
import UYN21 from "../images/commercials/UYN/UYN_FINAL_021 copy Medium.jpeg";
import UYN22 from "../images/commercials/UYN/UYN_FINAL_022 copy Medium.jpeg";


const UYN = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={UYN1} alt="UYN Commercial Photography - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={UYN2} alt="UYN Commercial Photography - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={UYN3} alt="UYN Commercial Photography - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={UYN4} alt="UYN Commercial Photography - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={UYN6} alt="UYN Commercial Photography - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={UYN5} alt="UYN Commercial Photography - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={UYN7} alt="UYN Commercial Photography - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={UYN8} alt="UYN Commercial Photography - Image 8"/>
                </div>
                <div className="single portrait">
                    <img src={UYN9} alt="UYN Commercial Photography - Image 9"/>
                </div>
                <div className="single portrait">
                    <img src={UYN10} alt="UYN Commercial Photography - Image 10"/>
                </div>
                <div className="single portrait">
                    <img src={UYN11} alt="UYN Commercial Photography - Image 11"/>
                </div>
                <div className="single portrait">
                    <img src={UYN12} alt="UYN Commercial Photography - Image 12"/>
                </div>
                <div className="single portrait">
                    <img src={UYN13} alt="UYN Commercial Photography - Image 13"/>
                </div>
                <div className="single portrait">
                    <img src={UYN14} alt="UYN Commercial Photography - Image 14"/>
                </div>
                <div className="single portrait">
                    <img src={UYN15} alt="UYN Commercial Photography - Image 15"/>
                </div>
                <div className="single portrait">
                    <img src={UYN16} alt="UYN Commercial Photography - Image 16"/>
                </div>
                <div className="single portrait">
                    <img src={UYN18} alt="UYN Commercial Photography - Image 18"/>
                </div>
                <div className="single portrait">
                    <img src={UYN17} alt="UYN Commercial Photography - Image 17"/>
                </div>
                <div className="single portrait">
                    <img src={UYN19} alt="UYN Commercial Photography - Image 19"/>
                </div>
                <div className="single portrait">
                    <img src={UYN20} alt="UYN Commercial Photography - Image 20"/>
                </div>
                <div className="single portrait">
                    <img src={UYN21} alt="UYN Commercial Photography - Image 21"/>
                </div>
                <div className="single portrait">
                    <img src={UYN22} alt="UYN Commercial Photography - Image 22"/>
                </div>
            </div>
        </div>
    );
}

export default UYN;